import React, { useContext, useEffect } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import CatalogSearch from '@Components/Search/CatalogSearch'
import CatalogCompactWorkItem from '@Components/WorkItemV2/Catalog/CatalogCompactWorkItem'
import CatalogExtendedWorkItem from '@Components/WorkItemV2/Catalog/CatalogExtendedWorkItem'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import CatalogMobileSubLinks from '@Components/Navigations/CatalogMobileSubLinks'
import { RightsholderCatalogFilterCollection } from '@App/forms/filters/rightsholder-catalog-filter'
import CatalogHeader from '@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogSearch/components/CatalogHeader'

const RightsholderCatalogSearch = () => {
    const { catalogSearchStore, userStore, uiStore, workStore, rightsholderStore } = useContext(StoresContext)

    useEffect(() => {
        analyticsSendPage('rightsholder_catalog')
        workStore.destroyViewWork()
    }, [])

    return (
        <>
            <CatalogHeader />
            {uiStore.isMobile && <CatalogMobileSubLinks />}
            <CatalogSearch
                userStore={userStore}
                claimedShares={rightsholderStore.rightsholderClaimedShares}
                catalogSearchStore={catalogSearchStore}
                compactWorkComponentType={CatalogCompactWorkItem}
                extendedWorkComponentType={CatalogExtendedWorkItem}
                searchFilters={RightsholderCatalogFilterCollection}
            />
        </>
    )
}

export default observer(RightsholderCatalogSearch)
